<template>
    <card-seplag>
        <div class="p-grid p-col-12" style="margin-top:10px;">
            <div class="p-md-6 p-col-12" @click="alternarPaginas('pendentes')">
                <!-- botões legenda: Pendentes | Deferidos | Não agendados -->                
                <Card class="card-button estiloPendentes" v-if="mostrarPendentes">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Pendentes</span>
                            </div>
                            <!-- <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1w;">{{("000" + this.countPendentes).slice(this.countPendentes.toString().split('').length> 3? "-"+this.countPendentes.toString().split('').length:-3)}}</span>
                            </div> -->
                        </div>                    
                    </template>
                </Card>
                <Card class="card-button" v-else>
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Pendentes</span>
                            </div>
                            <!-- <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countPendentes).slice(this.countPendentes.toString().split('').length> 3? "-"+this.countPendentes.toString().split('').length:-3)}}</span>
                            </div> -->
                        </div>                    
                    </template>
                </Card>
            </div>
            <div class="p-md-6 p-col-12"  @click="alternarPaginas('deferidos')">  
                <Card class="card-button estiloDeferidos" v-if="mostrarDeferidos">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Validados</span>
                            </div>
                            <!-- <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countDeferidos).slice(this.countDeferidos.toString().split('').length> 3? "-"+this.countDeferidos.toString().split('').length:-3)}}</span>
                            </div> -->
                        </div>                    
                    </template>
                </Card>
                <Card class="card-button" v-else>     
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Validados</span>
                            </div>
                            <!-- <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countDeferidos).slice(this.countDeferidos.toString().split('').length> 3? "-"+this.countDeferidos.toString().split('').length:-3)}}</span>
                            </div> -->
                        </div>                    
                    </template>
                </Card>
            </div>
            <!-- <div class="p-md-3 p-col-12" @click="alternarPaginas('naoAgendados')">
                <Card class="card-button estiloNaoAgendados" v-if="mostrarNaoAgendados">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Não Agendados</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countNaoAgendados).slice(this.countNaoAgendados.toString().split('').length> 3? "-"+this.countNaoAgendados.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
                <Card class="card-button" v-else>
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Não Agendados</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countNaoAgendados).slice(this.countNaoAgendados.toString().split('').length> 3? "-"+this.countNaoAgendados.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
            </div> -->
            <!-- <div class="p-md-3 p-col-12" @click="alternarPaginas('geral')">
                <Card class="card-button estiloGeral" v-if="mostrarGeral">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Geral</span>
                            </div> -->
                            <!-- <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countGeral).slice(this.countGeral.toString().split('').length> 3? "-"+this.countGeral.toString().split('').length:-3)}}</span>
                            </div> -->
                        <!-- </div>                    
                    </template>
                </Card> -->
                <!-- <Card class="card-button" v-else>
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Geral</span>
                            </div> -->
                            <!-- <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countGeral).slice(this.countGeral.toString().split('').length> 3? "-"+this.countGeral.toString().split('').length:-3)}}</span>
                            </div> -->
                        <!-- </div>                    
                    </template>
                </Card>                  
        </div>         -->
      <router-view />
	</div>  
  </card-seplag>
</template>

<script>
import CardSeplag from '../../template/CardSeplag.vue';
// import { baseApiUrl } from '@/config/global'; 
export default {
        name:"ChefiaAprovacaoFerias",
        components: { CardSeplag },
        data (){
        return{
            apiUrlRecurso: '',
            mostrarPendentes:false,
            mostrarDeferidos:false,
            mostrarNaoAgendados:false,
            mostrarGeral:false,
            countPendentes:0,
            countDeferidos:0,
            countNaoAgendados:0,
            // countGeral:0,
            tituloTabela: "",
            layout:"list",
            dadosAgendamentosPorSetor:[],
            dadosTabela:[],
            mostrarJson:[],            
            expandedRows : null,  
                                  
           }
        },                   
        methods: {     
            async carregarDados(){    
                // var options = {
                //     tipoAfastamento: 'ferias',
                //     matricula: this.$store.getters.getMatricula,
                //     vinculo: this.$store.getters.getVinculo,
                //     idenPessoa: this.$store.getters.getIdenPessoa,
                //     //idenEscalaAfastamento: this.escalaAnualRhSelecionada,
                // };
          /*
            carrega os contadores dos botões "Pendentes", "Deferidos" e "Não agendados"
             */                 

            //    var v_countP = await this.$http.get(`${baseApiUrl}/feriasview/chefia/countador/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/PENDENTE`)
            //    if(v_countP.status==200){
            //        this.countPendentes = v_countP.data
                   
            //     }          

            //     var v_countLPP = await this.$http.post(`${baseApiUrl}/programacaoafastamentos/chefia/count/pendentes`, JSON.stringify(options))
            //     if(v_countLPP.status==200){
            //         this.countPendentes = this.countPendentes + v_countLPP.data
            //     }

            //    var v_countD = await this.$http.get(`${baseApiUrl}/feriasview/chefia/countador/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/APROVADO`)
            //    if(v_countD.status==200){
            //        this.countDeferidos = v_countD.data
            //     } 

            //    var v_countLPD = await this.$http.post(`${baseApiUrl}/programacaoafastamentos/chefia/count/aprovados`, JSON.stringify(options))
            //    if(v_countLPD.status==200){
            //         this.countDeferidos = this.countDeferidos + v_countLPD.data
            //     } 

                
        //        var v_countNA = await this.$http.post(`${baseApiUrl}/direitoafastamentos/chefia/count/naoagendados`, JSON.stringify(options))
        //        if(v_countNA.status==200){
        //           this.countNaoAgendados = v_countNA.data
        //    }
         //  var v_countG = await this.$http.post(`${baseApiUrl}/programacaoafastamentos/chefia/count/geral`, JSON.stringify(options))
        //        if(v_countG.status==200){
        //            this.countGeral = v_countG.data
        //    }
        },
            
           async  alternarPaginas(click){                        
            if(click == 'pendentes'){
                this.$router.push({name:'feriasChefiaPendenteValidacao'}) 
                this.mostrarNaoAgendados = false;
                this.mostrarDeferidos = false;
                this.mostrarGeral = false;
                this.mostrarPendentes = true;
                this.tituloTabela = 'Agendamentos Pendentes';
            } else if(click == 'deferidos'){
               this.$router.push({name:'feriasChefiaValidos'})             
                this.mostrarNaoAgendados = false;
                this.mostrarPendentes = false;
                this.mostrarGeral = false;
                this.mostrarDeferidos = true;
                this.tituloTabela = 'Agendamentos Deferidos';
            } 
            // else if(click == 'naoAgendados'){
            //     this.$router.push({name:'feriasChefiaNaoAgendado'})
            //     this.mostrarDeferidos = false;
            //     this.mostrarPendentes = false;
            //     this.mostrarGeral = false;
            //     this.mostrarNaoAgendados = true;
            //     this.tituloTabela = 'Não Agendados';
            // } else if(click == 'geral'){
            //     this.$router.push({name:'feriasChefiaNaoAgendadoagenda'})
            //     this.mostrarDeferidos = false;
            //     this.mostrarPendentes = false;
            //     this.mostrarNaoAgendados = false;
            //     this.mostrarGeral = true;
            //     this.tituloTabela = 'Geral';
            // }      
             this.carregarDados();                          
         }     
     },

//     computed: {
//     estiloPendentes() {
//       return {
//         estiloPendentes: this.mostrarPendentes,
//         estiloOff: this.mostrarDeferidos || this.mostrarNaoAgendados,
//       };
//     },
//     estiloDeferidos() {
//       return {
//         estiloDeferidos: this.mostrarDeferidos,
//         estiloOff: this.mostrarPendentes || this.mostrarNaoAgendados,
//       };
//     },
//     estiloNaoAgendados() {
//       return {
//         estiloDeferidos: this.mostrarNaoAgendados,
//         estiloOff: this.mostrarPendentes || this.mostrarDeferidos,
//       };
//     }    
//  },                   
 mounted() {
    this.alternarPaginas('pendentes'); 
  }
}; 

</script>    
<style scoped>
.estiloPendentes {
  background: rgb(219, 171, 81);
  color: aliceblue;
}
.estiloDeferidos {
  background: #0ca852;
  color: aliceblue;
}
.estiloNaoAgendados {
  background: #f03a3a;
  color: aliceblue;
}
.estiloGeral{
   background: #005494;
    color: aliceblue;
}
.estiloOff{
    background: #ccc;
    color: grey;
}
.card-selecionado {
  background-color: #00bcd4;
  color: aliceblue;
}
.botao-status{
    /*width:155px; */
    margin:5px; 
    border:0; 
    font-weight: bold;
    font-size: 13px;
}

.botao-acao{
    margin:5px; 
    font-size: 13px;
    /*width:145px;*/
}

.button-badge {
    position: absolute;
    font-size: 10px;
    right: -5px;
    top: -5px;
    min-width: 20px;
    min-height: 18px;
    text-align: center;
    line-height: 18px;
    color: #fff;
    background-color: #ef6262;
    padding: 2px;
    border-radius: 50%;
}

.setor-badge {
    display: inline-block;
    margin-left: 4px;
    font-size: 13px;
    min-width: 20px;
    min-height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    background-color: #007be5;
    border-radius: 50%;
    padding: 2px;
}
.botao-titulo-status{    
    font-size: 15px;
    font-weight: bold;
}
.botao-quantidade-status{    
    background-color: #007be5;
    color: aliceblue;
    padding: 5px;
    font-size: 20px;
}
.card-button{    
    cursor: pointer;
}
 
</style>